import Axios from 'axios';
import { API, CONFIG } from '../utils/constant';

// Form Submission
function widgetFormSubmit() {
    const contactForm = document.querySelector('#modal-widget-form')
    if (contactForm == null || undefined) return

    // Form variable
    let salutation
    let firstname
    let lastname
    let email
    let phone
    let pdpa
    let isValid = false
    
    contactForm.addEventListener('submit', function(event){
        checkvalidation()
        event.preventDefault()

        if (isValid) {
            const payload = {
                full_name: `${salutation} ${firstname} ${lastname}`,
                email: email,
                phone_number: phone,
                bu_name: "EcoWorld Singapore",
                source: "Corporate Website"
            }

            Axios.post(
                API,
                payload,
                CONFIG
            ).then( res => {
                console.log(res.data);
                console.log(new Date().toLocaleTimeString());
                alert('Thank you for your registration.')
            }).catch( err => {
                console.log(err);
                if (err.response) {
                    console.log(err.response);
                }
            })
        }
    })
        
    function checkvalidation(){
        salutation = contactForm.querySelector('#widget-form-salutation').value
        firstname = contactForm.querySelector('#widget-form-first-name').value
        lastname = contactForm.querySelector('#widget-form-last-name').value
        email = contactForm.querySelector('#widget-form-email').value.toLowerCase()
        phone = contactForm.querySelector('#widget-form-phone').value
        pdpa = contactForm.querySelector('#widget-form-pdpa').checked
        
        if(salutation == ""){
            alert('Please select your salutation.')
            isValid = false
        }
        else if (firstname == ""){
            alert('Please fill up your first name.')
            isValid = false
        }
        else if (lastname == ""){
            alert('Please fill up your last name.')
            isValid = false
        }
        else if (!validateEmail(email)){
            alert('Please fill up your email.')
            isValid = false
        }
        else if (phone == ""){
            alert('Please fill up your contact number.')
            isValid = false
        }
        else if (!pdpa){
            alert('Please read and agree the Terms & Conditions.')
            isValid = false
        } else {
            isValid = true
        }
    
    }
    
    function validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}

export default widgetFormSubmit;